import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-xhr-backend';

let lang = window.location.hostname.split('.')[0];
if (lang !== 'it' && lang !== 'en') lang = 'en';

i18n
  .use(backend)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: ['form'],
    defaultNS: 'form',
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
      // path to post missing resources
      // addPath: 'locales/add/{{lng}}/{{ns}}'
    },
    fallbackLng: false,
    lng: lang,
    debug: false,
    saveMissing: false,
    nsSeparator: '::',
    keySeparator: false,
    pluralSeparator: '||',
    contextSeparator: '||',
    returnEmptyString: false,
    react: {useSuspense: true}
  });
//i18n.changeLanguage(lang)
export default i18n;